// extracted by mini-css-extract-plugin
export var button = "_lj-0";
export var donut = "_lj-1";
export var donutFill = "_lj-3";
export var donutTrack = "_lj-2";